import { TranslatedCategory } from '../interface/TranslatedCategory';

export const getCategories = async (
  auth: string,
  osm: boolean = false
): Promise<TranslatedCategory[] | string> => {
  const { REACT_APP_API_URL } = process.env;
  try {
    const endpoint = osm ? 'categories/osm-categories' : 'categories';

    const response = await fetch(`${REACT_APP_API_URL}/${endpoint}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: auth,
      },
    });

    const data = await response.json();

    if (response.ok) {
      return data;
    } else {
      return data.message || 'Error fetching categories';
    }
  } catch (error) {
    return (error as Error).message || 'Unknown error';
  }
};
